import React from "react";
import { withRouteData } from "react-static";

import Product from "./product";

export default withRouteData(({ product, productPageConfiguration }) => (
  <Product
    product={product}
    productPageConfiguration={productPageConfiguration}
  />
));
